import React, { useState } from 'react';
import cs from 'classnames';
import styles from './index.module.less';
import V2FormSelect from '../../../Form/V2FormSelect/V2FormSelect';
import V2FilterFooter from './V2FilterFooter';
import { useMethods } from '@lhb/hook';
import { isEqual, isNotEmpty, isNotEmptyAny } from '@lhb/func';
const V2FilterSelect: React.FC<any> = ({
  name,
  headFilter,
  setHeadFilter,
  cacheHeadFilter,
  close,
  options,
  multiple,
  comType,
  extra,
  comProps,
}) => {
  const [targetValue, setTargetValue] = useState<any>(headFilter[name]);
  const methods = useMethods({
    confirm(newValue, force = false) {
      close();
      if (force) {
        setHeadFilter({
          ...headFilter,
          [name]: newValue
        });
      } else if (!isEqual(headFilter[name], newValue)) {
        if (!isNotEmpty(newValue) && !isNotEmpty(headFilter[name])) {
          return;
        }
        setHeadFilter({
          ...headFilter,
          [name]: newValue
        });
      }
    },
    handleSearch() {
      methods.confirm(targetValue);
    },
    clearFiltersAndClose() {
      if (isNotEmptyAny(targetValue?.value)) {
        methods.confirm(undefined, true);
      } else {
        methods.confirm(undefined);
      }
      setTargetValue(undefined);
    }
  });
  return (
    <div className={cs([styles.V2TableFilterCommon, styles.V2FilterSelect])}>
      <div>
        <V2FormSelect
          placeholder='请选择'
          noStyle
          config={{
            defaultValue: targetValue?.value,
            maxTagCount: 'responsive',
            showSearch: true,
            ...(multiple ? { mode: 'multiple' } : {})
          }}
          options={options}
          onChange={value => {
            const newValue = {
              comType,
              value,
              extra
            };
            setTargetValue(newValue);
            cacheHeadFilter.current = {
              ...cacheHeadFilter.current,
              [name]: newValue
            };
          }}
          {...comProps}
        />
      </div>
      <V2FilterFooter
        handleSearch={methods.handleSearch}
        clearFiltersAndClose={methods.clearFiltersAndClose}
      />
    </div>
  );
};

export default V2FilterSelect;
